export const APPLICATION_OPTIONS = {
  byRatePerArea: {
    key: 'ByRatePerArea',
    value: 'ratePerAreaValue',
    unit: 'ratePerAreaUnit',
    title: 'Rate/Area'
  },
  byTotalProduct: {
    key: 'ByTotalProduct',
    value: 'totalProductValue',
    unit: 'totalProductUnit',
    title: 'Total Product'
  },
  byRatePerTank: {
    key: 'ByRatePerTank',
    value: 'ratePerTankValue',
    unit: 'ratePerTankUnit',
    title: 'Rate/Tank'
  }
};

export const timingOptions = [
  { key: 'None', value: 'None' },
  { key: 'Pre-Plant', value: 'Pre-Plant' },
  { key: 'Planting', value: 'Planting' },
  { key: 'Growing', value: 'Growing' },
  { key: 'Harvest', value: 'Harvest' },
  { key: 'Storage', value: 'Storage' },
  { key: 'Annual', value: 'Annual' }
];

export const productTypes = [
  { key: 'clear', value: '- Clear filter' },
  { key: 'custom', value: 'Custom Product' },
  { key: 'cropProtection', value: 'Crop Protection' },
  { key: 'fertilizer', value: 'Fertilizer' },
  { key: 'seed', value: 'Seed' },
  { key: 'service', value: 'Service' }
];
